import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Modal, Logo } from '@grandvisionhq/common';
import { LocaleUtils } from '@grandvisionhq/utils';
import LocaleOption from './LocaleOption.js';

const LocaleSelectOverlay = ({ availableLocales , logo  })=>{
    const [open, setOpen] = React.useState(false);
    React.useEffect(()=>{
        const urlLocale = LocaleUtils.getLocaleFromUrl(window.location.href);
        const cookieLocale = LocaleUtils.getLocaleFromCookie();
        cookieLocale !== urlLocale ? setLocaleCookieFromUrl() : setOpen(!cookieLocale && availableLocales.length > 0);
    }, [
        availableLocales
    ]);
    const handleLocaleSelect = React.useCallback((selectedLocale, path)=>{
        LocaleUtils.setLocaleToCookie(selectedLocale);
        setOpen(false);
        window && window.location.assign(LocaleUtils.getLocaleSwitchPath(path));
    }, []);
    const setLocaleCookieFromUrl = ()=>{
        const urlLocale = LocaleUtils.getLocaleFromUrl(window.location.href);
        setOpen(!!urlLocale);
        urlLocale && LocaleUtils.setLocaleToCookie(urlLocale);
    };
    return /*#__PURE__*/ React.createElement(Modal, {
        isOpen: open,
        showIcon: false,
        className: "locale-select-overlay",
        "data-t": "locale-overlay"
    }, logo && /*#__PURE__*/ React.createElement("div", {
        className: "locale-select-overlay__logo-wrapper"
    }, /*#__PURE__*/ React.createElement(Logo, {
        url: "/",
        image: logo
    })), /*#__PURE__*/ React.createElement("div", {
        className: "locale-select-overlay__content",
        "data-t": "locale-overlay-content"
    }, availableLocales.map((option)=>/*#__PURE__*/ React.createElement(LocaleOption, swcHelpers.extends({
            key: `locale-option-${option.locale}`
        }, option, {
            onSelect: handleLocaleSelect
        }))
    )));
};

export { LocaleSelectOverlay as default };
//# sourceMappingURL=LocaleSelectOverlay.js.map
